import React, {Suspense, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import "./locales/i18n"
import "./App.scss"
import {baseTheme, createTheme} from './styles/theme'
import {useTranslation} from "react-i18next";
import CssBaseline from "@material-ui/core/CssBaseline";
import ThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import iframResizer from "iframe-resizer"
import {is_truthy, isWhite} from "./utils";


let lang = 'en';
const debug = false;
const blackLogo = "https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/logo.png";
const whiteLogo = "https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/logo_bianco.png";

let loaded = false

function init() {
    if (loaded) return;
    loaded = true;
    render();
}

function render() {

    let {
        apiToken,
        type,
        footer,
        language,
        apiurl,
        props,
        customTheme,
        profilePic,
        stats,
    } = JSON.parse(decodeURI(window.location.href).split('=')[1])
    lang = language

    if (!apiurl) {
        apiurl = "https://server.recensioni.io/api/v0.0.9"
    }

    // handle iframe comunication
    window.addEventListener('message', event => {

        if (event.data) {
            if (event.data.includes('[widgetEvent]')) {
                const data = event.data.replace('[widgetEvent]', '')
                if (window['setTheme'])
                    window['setTheme'](data)
            }
        }
    });

    function WidgetRender() {
        const [theme, setTheme] = useState(customTheme)
        const [logo, setLogo] = useState(getLogo())

        function getTheme(themeVal) {
            const t = themeVal ? themeVal : theme
            return {...baseTheme, ...t}
        }

        function getLogo(theme) {
            const themeOption = getTheme(theme);
            let color
            switch (type) {
                case 'popup':
                    color = themeOption.card.color;
                    break;
                default:
                    color = themeOption.color
            }
            if (isWhite(color)) {
                return whiteLogo
            } else {
                return blackLogo
            }
        }

        // hack to update the theme dynamically from externally the iframe
        window['setTheme'] = (theme) => {
            try {
                if (typeof theme === 'string') {
                    theme = JSON.parse(theme)
                }
                setTheme(theme)

                // footer logo
                setLogo(getLogo(theme))

                // if (theme && theme.color && logo !== theme.color && theme.color === '#000000')
                //     setLogo("https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/logo.png")
                // else if (theme && theme.color && logo !== theme.color && theme.color === '#ffffff')
                //     setLogo("https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/logo_bianco.png")
                // else
                //     setLogo("https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/logo.png")
            } catch (e) {
                console.error('SET THEME ERROR', e)
            }
        }


        const {i18n} = useTranslation()

        useEffect(() => {
            i18n.changeLanguage(lang)
        }, [i18n])

        if (footer == null) {
            footer = true
        } else {
            footer = is_truthy(footer)
        }
        if (profilePic == null) {
            profilePic = true
        } else {
            profilePic = is_truthy(profilePic)
        }
        if (stats == null) {
            stats = true
        } else {
            stats = is_truthy(stats)
        }


        /*if (footer == null) {
            footer = true
        } else if (footer === "true") {
            footer = true
        } else if (footer === "false") {
            footer = false
        }*/

        function getTemplate() {
            switch (type) {
                case 'feed':
                    const FeedWidget = React.lazy(() => import("./components/Feed"))
                    return <FeedWidget seat_id={apiToken} apiUrl={apiurl} footer={footer} profilePic={profilePic}
                                       stats={stats} logo={logo} {...props} />
                case 'carousel':
                    const CarouselWidget = React.lazy(() => import('./components/Carousel'))
                    return <CarouselWidget seat_id={apiToken} apiUrl={apiurl} footer={footer} logo={logo}
                                           profilePic={profilePic} stats={stats} {...props}/>
                case 'badge':
                    const BadgeWidget = React.lazy(() => import("./components/badge"))
                    return <BadgeWidget seat_id={apiToken} apiUrl={apiurl} footer={footer} logo={logo}
                                        profilePic={profilePic} stats={stats} {...props}/>
                case 'popup':
                    const PopUpWidget = React.lazy(() => import("./components/popUp"))
                    return <PopUpWidget seat_id={apiToken} apiUrl={apiurl} footer={footer} logo={logo}
                                        profilePic={profilePic} stats={stats} {...props}/>
                default:
                    return null
            }
        }

        return <ThemeProvider theme={createTheme(getTheme())}>
            <CssBaseline/>
            <Suspense fallback={''}>
                {getTemplate()}
            </Suspense>
        </ThemeProvider>
    }

    ReactDOM.render(
        <WidgetRender/>,
        document.body
    );
}


if (debug) {

} else {
    init()
}




